import React, { useState } from "react";
import { Input, Row, Typography, Form, Col, Checkbox, Divider } from "antd";

const { Text } = Typography;

export const SettingsForm = (props) => {
  const {
    useForm,
    isInterestRecalculationEnabled,
    holdGuaranteeFunds,
    multiDisburseLoan,
    allowVariableInstallments,
  } = props;

  return (
    <Form layout="vertical" form={useForm}>
      <Row style={{ justifyContent: "space-between" }}>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Amortization</Text>}
            name={"amortizationType"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Interest Method</Text>} name={"interestType"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
    <Form.Item name={"equalAmortization"} >
        <Checkbox checked={isEqualAmortization} disabled><Text>Is Equal Amortization</Text></Checkbox>
    </Form.Item>
</Col> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Interest Calculation Period</Text>}
            name={"interestCalculationPeriodType"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Repayment Strategy</Text>}
            name={"transactionProcessingStrategyId"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
    <Form.Item name={"interestPeriodCalc"}>
        <Checkbox
            disabledchecked={allowPartialPeriodInterestCalcualtion}><Text>Calculate interest for exact days in partial period</Text></Checkbox>
    </Form.Item>
</Col> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Moratorium</Text>}
            name={"graceOnPrincipalPayment"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text hidden>graceOnInterestPayment</Text>}
            name={"graceOnInterestPayment"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Interest Free Period</Text>}
            name={"graceOnInterestCharged"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Arrears Tolerance</Text>}
            name={"inArrearsTolerance"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Days In Year</Text>} name={"daysInYearType"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Days In Month</Text>}
            name={"daysInMonthType"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
    <Form.Item label={<Text>Allow Fixing Of The Installment Amount</Text>} name={"canDefineInstallmentAmount"}>
        <Checkbox checked={canDefineInstallmentAmount} disabledspan={8} />
    </Form.Item>
</Col> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Text>
                Maximum number of days a loan may be overdue before becoming a
                NPA (non performing asset)
              </Text>
            }
            name={"overdueDaysForNPA"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          {" "}
          <Form.Item
            label={
              <Text>
                Number of days a loan may be overdue before moving into arrears
              </Text>
            }
            name={"graceOnArrearsAgeing"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>  <Form.Item label={<Text>Account moves out of NPA only after all arrears have been cleared?</Text>} name={"clearedArrears"}>
    <Checkbox disabledchecked={accountMovesOutOfNPAOnlyOnArrearsCompletion} />
</Form.Item>
</Col> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Principal Threshold (%) for Last Instalment</Text>}
            name={"principalThresholdForLastInstallment"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
    <Form.Item name={"allowVariableInstallments"}>
        <Checkbox checked={allowVariableInstallments} onChange={() => setVariableInstallmentsChecked(!variableInstallmentsChecked)} disabled><Text>Is Variable Installments Allowed?</Text></Checkbox>
    </Form.Item>
</Col> */}

        {allowVariableInstallments === true ? (
          <Row style={{ justifyContent: "space-between" }}>
            <Form.Item
              label={<Text>Variable Installments</Text>}
              name={"minimumGap"}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                placeholder="Minimum gap between"
              />
            </Form.Item>

            <Form.Item
              label={<Text hidden>Variable Installments</Text>}
              name={"maximumGap"}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                placeholder="Maximum gap between"
              />
            </Form.Item>

            <div></div>
          </Row>
        ) : null}
        {/* 
<Form.Item name={"canUseForTopup"}>
    <Checkbox checked={canUseForTopup} disabled><Text>Is allowed to be used for providing Topup Loans?</Text></Checkbox>
</Form.Item> */}

        <Divider orientation="left" orientationMargin="0">
          {"Interest Recalculation"}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"isInterestRecalculationEnabled"}
            label={<Text>Recalculate Interest</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>

        {isInterestRecalculationEnabled === true ? (
          <>
            <Row style={{ justifyContent: "space-between" }}>
              <Form.Item
                label={<Text>Pre-closure interest calculation rule</Text>}
                name={"preClosureInterestCalculationStrategy"}
              >
                <Input className="of-bold-disable-input" disabled />
              </Form.Item>

              <Form.Item
                label={<Text>Advance payments adjustment type</Text>}
                name={"rescheduleStrategyMethod"}
              >
                <Input className="of-bold-disable-input" disabled />
              </Form.Item>

              <Form.Item
                label={<Text>Interest recalculation compounding on</Text>}
                name={"interestRecalculationCompoundingMethod"}
              >
                <Input className="of-bold-disable-input" disabled />
              </Form.Item>
            </Row>
            <Row style={{ justifyContent: "space-between" }}>
              <div>
                <Form.Item
                  label={
                    <Text>Frequency for recalculate Outstanding Principal</Text>
                  }
                  name={"interestRateFrequencyType"}
                >
                  <Input className="of-bold-disable-input" disabled />
                </Form.Item>
              </div>

              <div>
                <Form.Item
                  label={<Text>Frequency Interval for recalculation</Text>}
                  name={"recalculationRestFrequencyInterval"}
                >
                  <Input className="of-bold-disable-input" disabled />
                </Form.Item>
              </div>

              <div>
                <Form.Item name={"isArrearsBasedOnOriginalSchedule"}>
                  <Checkbox>
                    <Text>
                      Is Arrears recognization based on original schedule
                    </Text>
                  </Checkbox>
                </Form.Item>
              </div>
            </Row>
          </>
        ) : null}

        <Divider orientation="left" orientationMargin="0">
          {"Guarantee Requirements"}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"holdGuaranteeFunds"}
            label={<Text>Place Guarantee Funds On-Hold?</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>

        {holdGuaranteeFunds === true ? (
          <Row style={{ justifyContent: "space-between" }}>
            <div>
              <Form.Item
                label={<Text>Mandatory Guarantee(%)</Text>}
                name={"mandatoryGuarantee"}
              >
                <Input className="of-bold-disable-input" disabled />
              </Form.Item>
            </div>

            <div>
              <Form.Item
                label={<Text>Minimum Guarantee from Own Funds(%)</Text>}
                name={"minimumGuaranteeFromOwnFunds"}
              >
                <Input className="of-bold-disable-input" disabled />
              </Form.Item>
            </div>

            <div>
              <Form.Item
                label={<Text>Minimum Guarantee from Guarantors Funds(%)</Text>}
                name={"minimumGuaranteeFromGuarantor"}
              >
                <Input className="of-bold-disable-input" disabled />
              </Form.Item>
            </div>
          </Row>
        ) : null}

        <Divider orientation="left" orientationMargin="0">
          {"Configurable Terms and Settings"}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"allowAttributeConfiguration"}
            label={
              <Text>
                Allow overriding select terms and settings in loan accounts
              </Text>
            }
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"amortization"} label={<Text>Amortization</Text>}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"transactionProcessingStrategy"}
            label={<Text>Repayment strategy</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"arrearsTolerance"}
            label={<Text>Arrears Tolerance</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"graceOnPrincipalAndInterest"}
            label={<Text>Moratarium</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"interestMethod"}
            label={<Text>Interest Method</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"interestCalcPeriod"}
            label={<Text>Interest Calculation Period</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"repaymentFrequency"}
            label={<Text>Repaid every</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"graceOnArrearsAging"}
            label={
              <Text>
                Number of days a loan may be overdue before moving into arrears
              </Text>
            }
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          {"Loan Tranche Details"}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"multiDisburseLoan"}
            label={<Text>Enable Multiple Disbursals</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>

        {multiDisburseLoan === true ? (
          <Row style={{ justifyContent: "space-between" }}>
            <Col span={24}>
              <Form.Item
                label={<Text>Maximum Tranche count </Text>}
                name={"maxTrancheCount"}
              >
                <Input className="of-bold-disable-input" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label={<Text>Maximum allowed outstanding balance</Text>}
                name={"outstandingLoanBalance"}
              >
                <Input className="of-bold-disable-input" />
              </Form.Item>
            </Col>
          </Row>
        ) : null}
      </Row>
    </Form>
  );
};
